import { Button, Card, Flex, Space } from 'antd';

function ThankYouMobile({ viewModel }) {
  const { token, goLogin, viewWebsite } = viewModel;

  return (
    <Card style={{ width: '100vw' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" align="center" style={{ textAlign: 'center' }}>
          <img alt="sipro-logo" width={200} style={{ borderRadius: '8px' }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500', textAlign: 'center' }}>Tài khoản của bạn đã được tạo thành công</span>
          <Flex align="center" justify="center">
            <Space direction="vertical" style={{ textAlign: 'center' }}>
              <Flex align="center" justify="center">
                <span>Cảm ơn bạn đã tin tưởng Sipro - nền tảng bán sỉ dành riêng cho nhà kinh doanh như bạn.</span>
              </Flex>

              <span>Đăng nhập để thiết lập website</span>
              <Flex align="center" justify="center">
                <Button type="primary" onClick={goLogin}>
                  Đăng nhập
                </Button>
              </Flex>

              <span>Xem website vừa tạo</span>
              <Flex align="center" justify="center">
                <Button type="primary" onClick={viewWebsite}>
                  Xem website
                </Button>
              </Flex>
            </Space>
          </Flex>
        </Space>
      </Flex>
    </Card>
  );
}

export default ThankYouMobile;
